import '../browse-dialog/browse-dialog';
import './path-editor.scss';

export default angular.module('installer.path-editor', ['installer.browse-dialog']).
  directive('pathEditor', (dialog, i18n) => ({
    restrict: 'E',
    template: require('./path-editor.html'),
    scope: {
      value: '=',
      allowFiles: '=',
      defaultValue: '=',
      title: '@dialogTitle',
      isDisabled: '=?',
      hint: '@',
      error: '=',
      beforeSelect: '&',
      openIfEmpty: '@'
    },
    bindToController: true,
    controllerAs: 'pathCtrl',
    controller($scope) {
      const ctrl = this;
      $scope.$watch(() => ctrl.error, () => {
        ctrl.errorMessage = ctrl.error;
      });

      const getStartPath = () => {
        if (ctrl.value) {
          return ctrl.value;
        }
        if (ctrl.openIfEmpty) {
          return ctrl.openIfEmpty;
        }
        return ctrl.value;
      };

      ctrl.browse = () => {
        delete ctrl.errorMessage;

        dialog.show({
          title: `Select ${ ctrl.title}`,
          template: require('../browse-dialog/browse-dialog.html'),
          data: {
            value: getStartPath(),
            defaultValue: ctrl.defaultValue,
            allowFiles: ctrl.allowFiles
          },
          buttons: [{
            label: ctrl.allowFiles ? 'Select' : 'Select Folder',
            default: true,
            action(data) {
              if (ctrl.beforeSelect) {
                ctrl.beforeSelect({path: data.getPath()}).then(() => {
                  ctrl.value = data.getPath();
                  dialog.hide();
                }, response => {
                  let errorMessage;

                  if (response.data.errors) {
                    errorMessage = response.data.errors[0].error_description;
                  } else {
                    errorMessage = i18n('Path is not accessible');
                  }

                  data.setPathError(errorMessage);
                });
              } else {
                ctrl.value = data.getPath();
                return true;
              }

              return false;
            }
          }, {
            label: i18n('Reset to default'),
            action(data) {
              data.setDefaultValue(ctrl.openIfEmpty);
              return false;
            }
          }, {
            label: i18n('Cancel')
          }]
        });
      };
    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/path-editor/path-editor.js